import React, { useState, useEffect, useContext } from "react";
import * as S from "./CompraStyle";
import Loading from "../Loading/Loader";
import { formatNumber } from "../../assets/utils";
import Modal from "./CompraModal/Modal";
import GoToPayment from "./GoToPayment/GoToPayment";
import DepositInfoModal from "./DepositInfoModal/DepositInfoModal";
import TabelaDeContratos from "../Tabelas/TabelaContratos";
import { AuthContext } from "../../context/AuthContext";
import SideBarBox from "../Sidebar/SideBarBox";
import { usePulse } from "../../context/LoadContext";
import { useMessage } from "../../context/MessageContext";
import RepurchaseModal from "./RepurchaseModal/RepurchaseModal";
import { contractService } from "../../Services/contractService";
import { FaCrown, FaInfoCircle } from "react-icons/fa";
import PopUp1, { POPUP1_SESSION_KEY } from "../PopUps/PopUp1";

export default function Compra() {
  const { userData, reloadUserData, goldenVariables, platformData, contracts } =
    useContext(AuthContext);
  const { showMessage } = useMessage();
  const { showPulse, hidePulse } = usePulse();
  const [showRepurchaseModal, setShowRepurchaseModal] = useState(false);
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [qttContratos, setQttContratos] = useState(5);
  const [simulado, setSimulado] = useState(false);
  const [resultadoSimulacao, setResultadoSimulacao] = useState({});
  const [modalCompra, setModalCompra] = useState(false);
  const [showGoToPayment, setShowGoToPayment] = useState(false);
  const [showDepositInfo, setShowDepositInfo] = useState(false);
  const [loading, setLoading] = useState(true);
  const [valorContratoUni, setValorContratoUni] = useState(0);
  const [minValueToBuy, setMinValueToBuy] = useState(5);
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await contractService.getContractPlans();
        setPlans(data);
      } catch (error) {
        console.error("Erro ao carregar planos", error);
      }
    };

    if (goldenVariables) {
      const minQtt = goldenVariables.minContractQtt || 5;
      setValorContratoUni(goldenVariables.contractUniPrice);
      setMinValueToBuy(minQtt);
      setQttContratos(minQtt);
      setLoading(false);
      fetchPlans();
    }
  }, [goldenVariables]);

  const handleRepurchaseModal = () => {
    if (!simulado) {
      showMessage("Você precisa simular uma quantidade primeiro.", "warning");
      return;
    }
    if (parseInt(qttContratos, 10) < 10) {
      showMessage(
        "A quantidade mínima para recompra é de 10 contratos.",
        "warning"
      );
      return;
    }
    setShowRepurchaseModal(true);
  };

  const handleIncreaseInputQtt = (amount) => {
    setQttContratos((prev) => {
      const currentQtt = parseInt(prev, 10) || 0;
      const newQtt = currentQtt + amount;
      return Math.max(minValueToBuy, newQtt);
    });
  };

  const handleChangeInput = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue)) {
      setQttContratos(newValue);
    }
  };

  const handleSimulate = async () => {
    const qtt = parseInt(qttContratos, 10);

    if (qtt < minValueToBuy) {
      showMessage(
        `A quantidade mínima é de ${minValueToBuy} contratos.`,
        "warning"
      );
      return;
    }

    const alreadySeen = sessionStorage.getItem(POPUP1_SESSION_KEY);
    const hasActiveContract = contracts?.some(
      (c) => c.contract?.status === 1 || c.contract?.status === 2
    );
    if (!alreadySeen && !hasActiveContract) {
      setShowPopUp1(true);
      return;
    }

    showPulse();
    try {
      const data = await contractService.simulateProfit(qtt);
      setResultadoSimulacao(data);
      setSimulado(true);
    } catch (error) {
      showMessage("Erro ao processar simulação no servidor.", "error");
      console.error(error);
    } finally {
      hidePulse();
    }
  };

  const handleModalCompra = () => {
    if (!simulado) {
      showMessage("Você precisa simular a compra primeiro.", "warning");
      return;
    }
    const totalValue = qttContratos * valorContratoUni;
    if (totalValue > 4300000) {
      showMessage(
        "Valor não autorizado. Por favor, contate a empresa.",
        "error"
      );
      return;
    }
    setModalCompra(true);
  };

  const handlePurchaseSuccess = () => {
    reloadUserData();
    setModalCompra(false);
    setShowGoToPayment(true);
  };

  const handleRepurchaseSuccess = () => {
    reloadUserData();
    setShowRepurchaseModal(false);
  };

  const handleShowDepositInfo = () => {
    setShowGoToPayment(false);
    setShowDepositInfo(true);
  };

  const availableBalance = platformData?.platformWithdrawAvaliable || 0;

  if (loading) {
    return (
      <SideBarBox>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Loading />
        </div>
      </SideBarBox>
    );
  }

  return (
    <SideBarBox>
      <S.PageContainer>
        <S.Header>
          <S.Title>Aquisição de Contratos</S.Title>
          <S.Subtitle>
            Simule e adquira novos contratos para potencializar seus ganhos.
          </S.Subtitle>
        </S.Header>

        <S.MainCard>
          {userData?.isVipClient ? (
            <S.VipBanner>
              <div className="vip-icon">
                <FaCrown />
              </div>
              <div className="vip-info">
                <h3>Benefício VIP Ativo</h3>
                <p>
                  Como <strong>Cliente VIP</strong>, você possui uma taxa de
                  valorização exclusiva de <strong>4,1% ao mês</strong> em todas
                  as suas aquisições.
                </p>
                <small>
                  <FaInfoCircle /> Quantidade mínima para compra:{" "}
                  {minValueToBuy} contratos.
                </small>
              </div>
            </S.VipBanner>
          ) : (
            plans.length > 0 && (
              <S.PlansContainer>
                {plans.map((plan, index) => (
                  <S.PlanTier key={index}>
                    <S.TierLabel>ACIMA DE {plan.min_qtt} CONTRATOS</S.TierLabel>
                    <S.TierValue>{plan.percentage}% / MÊS</S.TierValue>
                  </S.PlanTier>
                ))}
              </S.PlansContainer>
            )
          )}

          <S.Step>
            <S.StepHeader>
              <S.StepNumber>1</S.StepNumber>
              <S.StepTitle>Defina a Quantidade</S.StepTitle>
            </S.StepHeader>
            <S.InputContainer>
              <S.QuantityButton onClick={() => handleIncreaseInputQtt(-1)}>
                -
              </S.QuantityButton>
              <S.QuantityInput
                type="number"
                min={minValueToBuy}
                onChange={handleChangeInput}
                onBlur={() => {
                  if (parseInt(qttContratos, 10) < minValueToBuy)
                    setQttContratos(minValueToBuy);
                }}
                value={qttContratos}
              />
              <S.QuantityButton onClick={() => handleIncreaseInputQtt(1)}>
                +
              </S.QuantityButton>
            </S.InputContainer>
            <S.PresetButtons>
              {[100, 500, 1000, 5000, 10000].map((val) => (
                <S.PresetButton key={val} onClick={() => setQttContratos(val)}>
                  {val}
                </S.PresetButton>
              ))}
            </S.PresetButtons>
            <S.TotalCost>
              VALOR TOTAL:{" "}
              <span>R$ {formatNumber(qttContratos * valorContratoUni)}</span>
            </S.TotalCost>
          </S.Step>

          <S.Step>
            <S.StepHeader>
              <S.StepNumber>2</S.StepNumber>
              <S.StepTitle>Simule seus Ganhos</S.StepTitle>
            </S.StepHeader>
            <S.ActionButton onClick={handleSimulate}>
              Simular Valorização
            </S.ActionButton>
          </S.Step>

          {simulado && (
            <S.SimulationResult>
              <S.Step>
                <S.StepHeader>
                  <S.StepNumber>3</S.StepNumber>
                  <S.StepTitle>Confirme e Adquira</S.StepTitle>
                </S.StepHeader>
                <S.ResultGrid>
                  <S.ResultCard>
                    <S.ResultLabel>Valorização Diária</S.ResultLabel>
                    <S.ResultValue>
                      R$ {formatNumber(resultadoSimulacao.dailyProfit)}
                    </S.ResultValue>
                  </S.ResultCard>
                  <S.ResultCard>
                    <S.ResultLabel>Valorização Total</S.ResultLabel>
                    <S.ResultValue>
                      R$ {formatNumber(resultadoSimulacao.totalProfit)}
                    </S.ResultValue>
                  </S.ResultCard>
                  <S.ResultCard>
                    <S.ResultLabel>Prazo Final</S.ResultLabel>
                    <S.ResultValue>
                      {resultadoSimulacao.totalDays} dias
                    </S.ResultValue>
                  </S.ResultCard>
                </S.ResultGrid>
                <S.ActionButton onClick={handleModalCompra}>
                  Realizar Compra
                </S.ActionButton>
                <S.SecondaryActionButton onClick={handleRepurchaseModal}>
                  Recomprar com Saldo
                </S.SecondaryActionButton>
              </S.Step>
            </S.SimulationResult>
          )}
        </S.MainCard>

        <S.TabelaContainer>
          <S.TabelaHeader>
            <h2>Meus Contratos</h2>
          </S.TabelaHeader>
          <TabelaDeContratos />
        </S.TabelaContainer>

        {modalCompra && (
          <Modal
            onPurchaseSuccess={handlePurchaseSuccess}
            handleModalCompra={() => setModalCompra(false)}
            modalData={{
              meses: resultadoSimulacao.totalDays / 30,
              dias: resultadoSimulacao.totalDays,
              lucroDiario: resultadoSimulacao.dailyProfit,
              porcentagemLucro:
                (resultadoSimulacao.totalProfit /
                  resultadoSimulacao.initialValue) *
                100,
              qttContratos: resultadoSimulacao.qttContratos,
              valorPorContrato: valorContratoUni,
              lucroTotal: resultadoSimulacao.totalProfit,
            }}
          />
        )}

        {showGoToPayment && (
          <GoToPayment
            onClose={() => setShowGoToPayment(false)}
            onPayNow={handleShowDepositInfo}
          />
        )}

        {showDepositInfo && (
          <DepositInfoModal onClose={() => setShowDepositInfo(false)} />
        )}

        {showPopUp1 && (
          <PopUp1 onClose={() => setShowPopUp1(false)} />
        )}

        {showRepurchaseModal && (
          <RepurchaseModal
            modalData={{
              meses: resultadoSimulacao.totalDays / 30,
              dias: resultadoSimulacao.totalDays,
              lucroDiario: resultadoSimulacao.dailyProfit,
              porcentagemLucro:
                (resultadoSimulacao.totalProfit /
                  resultadoSimulacao.initialValue) *
                100,
              qttContratos: resultadoSimulacao.qttContratos,
              valorPorContrato: valorContratoUni,
              lucroTotal: resultadoSimulacao.totalProfit,
            }}
            totalCost={qttContratos * valorContratoUni}
            availableBalance={availableBalance}
            onClose={() => setShowRepurchaseModal(false)}
            onSuccess={handleRepurchaseSuccess}
          />
        )}
      </S.PageContainer>
    </SideBarBox>
  );
}
